export {default as Pagination} from './pagination-redux';
